import { lazy } from "react"
import { RouteProps } from "../features.types"

const FinApiController = lazy(() => import("./finapi-controller"))
const FinApiHome = lazy(() => import("./finapi-home"))
const ApiDocs = lazy(() => import("./api-docs"))
const Settings = lazy(() => import("./settings"))
const TenantOrders = lazy(() => import("../admin/tenant-orders"))
// define route constant

export const FIN_API_ROOT = "finapi"
export const FIN_API_DASHBOARD = "finapi/dashboard"
export const FIN_API_DOCS_ROUTE = "finapi/api-docs"
export const FIN_API_SETTINGS_ROUTE = "finapi/settings"
export const FIN_API_TRANSACTIONS_LIST_ROUTE = "finapi/transactions-list"

//define routes
export const FinApi: RouteProps[] = [
  {
    path: "",
    Component: FinApiController,
    children: [
      {
        path: `/${FIN_API_DASHBOARD}`,
        Component: FinApiHome,
      },
      {
        path: `/${FIN_API_DOCS_ROUTE}`,
        Component: ApiDocs,
      },
      {
        path: `/${FIN_API_TRANSACTIONS_LIST_ROUTE}`,
        Component: TenantOrders,
      },
      {
        path: `/${FIN_API_SETTINGS_ROUTE}`,
        Component: Settings,
      },
    ],
  },
]

export const finApiRoutes: RouteProps[] = [
  {
    path: "dashboard",
    Component: FinApiHome,
  },
  {
    path: `/${FIN_API_DOCS_ROUTE}`,
    Component: ApiDocs,
  },
  {
    path: `/${FIN_API_DOCS_ROUTE}`,
    Component: ApiDocs,
  },
  {
    path: `/${FIN_API_TRANSACTIONS_LIST_ROUTE}`,
    Component: TenantOrders,
  },
  {
    path: `/${FIN_API_SETTINGS_ROUTE}`,
    Component: Settings,
  },
]
